import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.find.js";
import React, { useCallback, useState } from 'react';

var compareCitations = function compareCitations(a, b) {
  return a.publication === b.publication && a.title === b.title && a.accessDate === b.accessDate && a.showInline === b.showInline;
};

var hasCitation = function hasCitation(citations, citation) {
  return citations.filter(function (cit) {
    return compareCitations(cit, citation);
  }).length > 0;
};

var CitationContext = /*#__PURE__*/React.createContext(null);

var CitationContextProvider = function CitationContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      inlineCitations = _useState2[0],
      setInlineCitations = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      extraCitations = _useState4[0],
      setExtraCitations = _useState4[1];

  var registerCitation = useCallback(function (citation) {
    var setCitations = citation.showInline ? setInlineCitations : setExtraCitations;
    setCitations(function (citationList) {
      // Don't register the same citation twice
      return hasCitation(citationList, citation) ? citationList : [].concat(_toConsumableArray(citationList), [citation]);
    });
  }, []);
  var unregisterCitation = useCallback(function (citation) {
    var setCitations = citation.showInline ? setInlineCitations : setExtraCitations;
    setCitations(function (c) {
      var newCitations = c.filter(function (cit) {
        return !compareCitations(cit, citation);
      });

      if (c.length === newCitations.length) {
        return c;
      }

      return newCitations;
    });
  }, []);
  var selectCitation = useCallback(function (citation) {
    var citationArray = _toConsumableArray(inlineCitations);

    citationArray.forEach(function (c) {
      // eslint-disable-next-line no-param-reassign
      c.selected = false;
    });
    var selectedCitation = citationArray.find(function (c) {
      return compareCitations(c, citation) === true;
    });

    if (!selectedCitation) {
      return;
    }

    selectedCitation.selected = true;
    setInlineCitations(citationArray);
  }, [inlineCitations]);
  var getCitationIndex = useCallback(function (citation) {
    return citation.showInline ? inlineCitations.indexOf(citation) : extraCitations.indexOf(citation);
  }, [inlineCitations, extraCitations]);
  return /*#__PURE__*/React.createElement(CitationContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(CitationContext.Provider, {
      value: context !== null && context !== void 0 ? context : {
        registerCitation: registerCitation,
        unregisterCitation: unregisterCitation,
        selectCitation: selectCitation,
        inlineCitations: inlineCitations,
        extraCitations: extraCitations,
        getCitationIndex: getCitationIndex
      }
    }, children);
  });
};

export default CitationContext;
export { CitationContextProvider };